import { useEffect } from 'react';

type PageEvents = {
  enter: () => void;
};

/**
 * Utility hook to call both enter/exit page events when a component mounts/unmounts.
 *
 * Note: this should only be used in components that act as routes or is conditionally mounted.
 *
 * For maximum flexibility, you can create a custom page event object that wraps the actual
 * telemetry page event -- you can then pass whatever arguments you want.
 *
 * @example
 * const { homePage } = useSomeTelemetry();
 *
 * const wrappedHomePageEvent = useCallback(() => {
 *  return {
 *    enter: (): void => {
 *      homePage.enter({ key: 'value' })
 *    }
 *  }
 * }, [homePage]);
 *
 * useTelemetryPageEvent(homePage);
 */
export const useTelemetryPageEvent = (pageEvents: PageEvents) => {
  useEffect(() => {
    pageEvents.enter();
  }, [pageEvents]);
};
